import { Part, Resultat, Decoupage, ResultatDecoupe, TrancheCalculee } from '../types';

export function arrondiBase(x: number, base: number): number {
  return Math.round(x / base) * base;
}

export function repartir(montant: number, parts: Part[], base = 50): Resultat[] {
  const totalPoids = parts.reduce((s, p) => s + p.poids, 0);
  if (totalPoids === 0) return [];

  const resultats: Resultat[] = parts.map((p, i) => {
    const brut = montant * p.poids / totalPoids;
    const part = arrondiBase(brut, base);
    const ecartArrondi = brut - Math.round(brut / base) * base;
    return { ...p, index: i, brut, part, ecartArrondi, ajuste: false, pourcentage: 0 };
  });

  let ecartTotal = montant - resultats.reduce((s, r) => s + r.part, 0);
  const nbAjust = Math.round(Math.abs(ecartTotal) / base);
  const sens = ecartTotal >= 0 ? 1 : -1;

  if (nbAjust > 0) {
    const indices = [...resultats]
      .sort((a, b) => (b.ecartArrondi * sens) - (a.ecartArrondi * sens))
      .map(r => r.index);
    for (let k = 0; k < nbAjust; k++) {
      resultats[indices[k]].part += sens * base;
      resultats[indices[k]].ajuste = true;
    }
  }

  const total = resultats.reduce((s, r) => s + r.part, 0);
  resultats.forEach(r => { r.pourcentage = total > 0 ? (r.part / total * 100) : 0; });

  return resultats;
}

export function appliquerDecoupage(
  resultats: Resultat[],
  decoupage: Decoupage,
  base = 50
): ResultatDecoupe[] {
  const { tranches } = decoupage;
  if (!tranches || tranches.length === 0) {
    return resultats.map(r => ({ ...r, tranchesDecoupage: [] }));
  }

  return resultats.map(r => {
    const calc: TrancheCalculee[] = tranches.map(t => {
      const brut = r.part * t.pourcentage / 100;
      return { ...t, brut, montant: arrondiBase(brut, base) };
    });

    const ecart = r.part - calc.reduce((s, t) => s + t.montant, 0);
    const nbAjust = Math.round(Math.abs(ecart) / base);
    const sens = ecart >= 0 ? 1 : -1;

    if (nbAjust > 0) {
      const indices = calc
        .map((t, i) => ({ i, err: t.brut - t.montant }))
        .sort((a, b) => (b.err * sens) - (a.err * sens))
        .map(x => x.i);
      for (let k = 0; k < nbAjust && k < indices.length; k++) {
        calc[indices[k]].montant += sens * base;
      }
    }

    return { ...r, tranchesDecoupage: calc };
  });
}

export function fmt(n: number): string {
  return Math.round(n).toLocaleString('fr-FR');
}

export function fmtPct(n: number): string {
  return n.toFixed(2) + ' %';
}
